  
    
    <div *ngIf="(switch=='S') || (switch=='A')" >
        <div *ngIf="(switch=='S') || (switch=='A')">
            <div class="speechtexticon" [ngClass]="position !== 'default' ? 'speechtexticon--' + position : ''">

                <!-- <img style="width: 40px; height: 40px; margin: 10px; cursor: pointer;" src="../../assets/microphone-3404243_960_720.png" (click)="startSpeechRecognition()"> -->
                <img *ngIf="!isStart  && !recording" class="before-start-mic" src="../../../assets/images/icon-mic.png"
                    (click)="startRecognitionAndRecording()" [ngClass]="{'img-disabled': isDisabled}">
                <img *ngIf="isStart && recording" class="after-start-mic" src="../../../assets/images/icon-mic-active.png"
                    (click)="stopRecognitionAndRecording()">
                <!-- <p *ngIf="!isStart" class="before-start-label"> Click  to ask</p>
                <p *ngIf="isStart" class="after-start-label"> Click  to stop</p> -->
    </div>